import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Button, Col, Form, Row, DatePicker, Card, Select, Modal, message, InputNumber} from 'antd';
import Input from '../../ui/Input';
import { LocalPersistence } from '../../../factories';
import { deleteAward, updateAward } from '../../../services/affiliations';
import moment from 'moment';
import PageContainer from '../../CSIComponents/PageContainer';
import DetailItem from '../../CSIComponents/DetailItem';
import Loading from '../../Loading';
import styles from '../styles.module.css';
import { disableTheDaysToCome } from './../../../helpers/misc/dateValidate';
import ActionButtonsBar from '../../ui/ActionButtonsBar';

const dateFormat = 'MM/DD/YYYY';
const { Option } = Select;

const EditAward = (props: any) => {
  const [detailData, setDetailData] = useState([
    { label: 'Award Name', value: props.rowData.name, span: 6 },
    { label: 'Date Awarded', value: props.rowData.dateawarded, span: 6 },
    { label: 'Official Appointment', value: props.rowData.officialappointment, span: 6 },
    { span: 5 },
    { label: 'Provider', value: props.rowData.provider, span: 6 },
    { label: 'Rating', value: props.rowData.rating, span: 6 },
    { label: 'Rating Symbol', value: props.rowData.ratingsymbol, span: 6 },
    { span: 5 },
  ])
  const [detailRowData, setDetailRowData] = useState(props.rowData);
  const [editFlag, setEditFlag] = useState(false);
  const [addLoading, setAddLoading] = useState(false)
  const [disabledStatus, setDisabledStatus] = useState(true)
  const [form] = Form.useForm();
  const options = ['Crown','Diamond','Star']

  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
  const ModalHead = () => {
    return (
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        height: '50px',
        lineHeight: '50px',
        textIndent: '10px',
        borderBottom: '1px solid #ccc',
        color: '#fff',
        background: '#06789D',
        fontSize: 18,
        width: '100%'
      }}>Confirm</div>
    )
  }
  const DeleteClick = async () => {
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    const params = {
      "supplier": session.supplier,
      "propertyId": session.propertyId,
      "property": {
        "affiliations": {
          "awards": [
            {
              awardid: props.rowData.awardid,
              awardlangid: props.rowData.awardlangid,
            }
          ]
        }
      }
    }
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete ${detailRowData.name} ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk: async () => {
        const res = await deleteAward(params);
        if (res.result.success) {
          form.resetFields();
          props.cancelAddAndEdit();
        }
      },
      onCancel() {

      },
    });


  }
  const addSave = () => {
    form.validateFields().then(async (value) => {
      const get_session = new LocalPersistence('session')
      const session: any = await get_session.getSessionPersistence()
      const params = {
        "supplier": session.supplier,
        "propertyId": session.propertyId,
        "property": {
          "affiliations": {
            "awards": [
              {
                ...value,
                dateawarded: (value.dateawarded && moment(value.dateawarded).format(dateFormat)) || "",
                awardid: props.rowData.awardid,
                awardlangid: props.rowData.awardlangid,
              }
            ]
          }
        }
      }
      setAddLoading(true)
      updateAward(params).then(res => {
        setAddLoading(false)
        if (res.result.success) {
          form.resetFields();
          setDetailRowData({ ...value, dateawarded: (value.dateawarded && moment(value.dateawarded).format(dateFormat)) || "" })
          setEditFlag(false);
          props.cancelEditable();
          props.disableTabPanes(false);
        } else {
          message.error({
            content: res?.error[0]?.message || 'operation failed'
          });
        }
      }, err => {
        message.error({
          content: err?.message || err?.error[0]?.message
        });
        setAddLoading(false)
      })
    })
  }
  const editHandle = () => {
    setEditFlag(true);
    const initialValues = {
      dateawarded: detailRowData.dateawarded ? moment(detailRowData.dateawarded, dateFormat) : '',
      name: detailRowData.name,
      officialappointment: detailRowData.officialappointment,
      provider: detailRowData.provider,
      rating: detailRowData.rating,
      ratingsymbol: detailRowData.ratingsymbol,
    }
    form.setFieldsValue(initialValues);
  }
  useEffect(() => {
    setDetailData([
      { label: 'Award Name', value: detailRowData.name, span: 6 },
      { label: 'Date Awarded', value: detailRowData.dateawarded, span: 6 },
      { label: 'Official Appointment', value: detailRowData.officialappointment, span: 6 },
      { span: 5 },
      { label: 'Provider', value: detailRowData.provider, span: 6 },
      { label: 'Rating', value: detailRowData.rating, span: 6 },
      { label: 'Rating Symbol', value: detailRowData.ratingsymbol, span: 6 },
      { span: 5 },
    ])
  }, [detailRowData])
  const validateFieldsError = (isDisabled?: boolean) => {
    if (isDisabled) {
      setDisabledStatus(isDisabled)
      return;
    }
    form.validateFields().then(() => {
      setDisabledStatus(false)

    }).catch(() => {
      const errTotalNum = form.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;

      if (errTotalNum === 0) {
        setDisabledStatus(false)
      } else {
        setDisabledStatus(true)
      }

    })
  }

  useEffect(() => {
    validateFieldsError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  if (addLoading) return <Loading type='large' />
  return !editFlag ? (
    <PageContainer>
      <Card style={{ marginTop: -15 }}>
        <Grid container spacing={0} className='containerSpacing py-0'>
          <Grid item xs={12} className='p-0'>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ margin: '0 10px 0 0' }}>
                <Button
                  type='primary'
                  className='db-edit-btn'
                  onClick={() => {
                    props.cancelAddAndEdit()
                    form.resetFields()
                  }}>
                  Back
                </Button>
              </div>
              <div>
                <Button
                  type='primary'
                  className='db-edit-btn'
                  onClick={() => {
                    editHandle()
                    props.isEditable()
                    props.disableTabPanes(true)
                  }}>
                  Edit
                </Button>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} className='p-0'>
            <div
              className={styles.titleStyles}
              style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
              {detailRowData.name}
            </div>
          </Grid>
          <Grid item xs={12} className='pb-0 px-0 my-0'>
            <Row gutter={24}>
              {detailData.map((item, i) => {
                return item.label ? (
                  <Col span={item.span} key={i} className='col-margin'>
                    <DetailItem value={item.value} label={item.label} />
                  </Col>
                ) : (
                  <Col span={item.span} key={i}></Col>
                )
              })}
            </Row>
          </Grid>
        </Grid>
      </Card>
    </PageContainer>
  ) : (
    <PageContainer>
      <Card style={{ marginTop: -15 }}>
        <Grid container spacing={0} className='containerSpacing py-0'>
          <Grid item xs={12} className='p-0'>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}> */}
            <div>
              <div
                className={styles.titleStyles}
                style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
                {detailRowData.name}
              </div>
              {/* <div><Button onClick={addSave}>Edit</Button></div> */}
            </div>
          </Grid>
          <Grid item xs={12} className='pb-0 px-0 my-0'>
            <Form
              layout='vertical'
              form={form}
              name='basic'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              onValuesChange={(changedFields, allFields) => {
                validateFieldsError()
              }}>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label='Award Name'
                    name='name'
                    rules={[
                      {
                        max: 255,
                        message:
                          'You have reached the max character length of 255',
                      },
                    ]}>
                    <Input maxLength={255} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label='Date Awarded' name='dateawarded'>
                    <DatePicker
                      format={dateFormat}
                      disabledDate={disableTheDaysToCome}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name='officialappointment'
                    label='Official Appointment'>
                    <Select allowClear showSearch>
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label='Provider'
                    name='provider'
                    rules={[
                      {
                        max: 50,
                        message:
                          'You have reached the max character length of 50',
                      },
                    ]}>
                    <Input maxLength={50} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label='Rating'
                      name='rating'
                    rules={[
                      {
                        pattern: /^[0-9]+$/,
                        message: 'This field should be an integer number',
                      },
                      {
                        pattern: /\b([0-9]|[1-9][0-9])\b/,
                        message: 'This field should be number between 0 and 99',
                      },
                    ]}>
                      <InputNumber className='antInputNumber' />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name='ratingsymbol' label="Rating Symbol" >
                    <Select allowClear showSearch>
                      { options.map(opt => <Option value={opt}>{ opt }</Option>) }
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
      </Card>
      <ActionButtonsBar
        onDelete={DeleteClick}
        onCancel={() => {
          props.cancelEditable()
          props.disableTabPanes(false)
          setEditFlag(false)
          form.resetFields()
        }}
        onSave={addSave}
        disabledSave={disabledStatus}
      />
    </PageContainer>
  )
}
export default EditAward;
